import React, { useState, useEffect } from "react";
import LogoMark from "./LogoMark";

const Navbar = ({ onServices, onAbout, onWhy, onContact }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [mobileOpen]);

  const toggleMobile = () => setMobileOpen(!mobileOpen);
  const closeMobile = () => setMobileOpen(false);

  const navlinks = [
    {
      label: "Services",
      onClick: () => {
        onServices();
        closeMobile();
      },
    },
    {
      label: "About",
      onClick: () => {
        onAbout();
        closeMobile();
      },
    },
    {
      label: "Why Us",
      onClick: () => {
        onWhy();
        closeMobile();
      },
    },
    {
      label: "Contact",
      onClick: () => {
        onContact();
        closeMobile();
      },
    },
  ];

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <a href="/" className="nav-logo">
        <LogoMark width={54} height={54} />
        <span className="nav-logo-text">Gauweng</span>
      </a>

      <ul className="nav-links">
        {navlinks.map((link) => (
          <li key={link.label}>
            <button onClick={link.onClick} className="nav-link-btn">
              {link.label}
            </button>
          </li>
        ))}
      </ul>

      <button
        onClick={() => {
          onContact();
          closeMobile();
        }}
        className="btn-primary nav-cta"
      >
        Free Consult
      </button>

      <button className="hamburger" onClick={toggleMobile} aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      {mobileOpen && (
        <div className="mobile-menu">
          {navlinks.map((link) => (
            <button
              key={link.label}
              onClick={link.onClick}
              className="mobile-menu-link"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
